export default __webpack_public_path__ + "static/media/gb-wls.9a19aa39.svg";